export default "__VITE_ASSET__SH495PR9__"